<template>
  <div class="row m-0 p-0">
    <div class="col m-0 p-0 align-self-center">
      {{ info }}
    </div>
    <div>
      <base-button icon round size="sm" type="warning" class="m-0 d-inline-block" @click.native="fullShow = !fullShow">
        <i :class="{'mdi':true, 'mdi-24px':true, 'mdi_icon':true, 'mdi-eye-outline': !fullShow, 'mdi-eye-off-outline': fullShow}"/>
      </base-button>
    </div>
  </div>
</template>
<script>

export default {
  name: "RestrictedInfo",
  components: {},
  props: {
    details: {
      type: String,
      required: true,
    },
    showLastN: {
      type: Number,
      required: false,
      default: 4
    }
  },
  data() {
    return {
      fullShow: false
    };
  },
  computed: {
    info() {
      if (this.fullShow) {
        return this.details
      }

      if (this.details.length > this.showLastN) {
        return '****' + this.details.slice(-this.showLastN);
      } else {
        return this.details
      }
    }
  },
};
</script>
